import { render, staticRenderFns } from "./ClientDetailPage.vue?vue&type=template&id=8b34a650&scoped=true&"
import script from "./ClientDetailPage.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ClientDetailPage.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b34a650",
  null
  
)

export default component.exports